import { isResource } from '@medplum/core'
import { codeableConcept, hasCodeableConcept } from '#src/codeableConcept.ts'
import { LIBRARY_TOPIC } from '#src/codeSystems.ts'
import {
  CompositionLibraryEncoded,
  type LibrarySection,
} from '#src/models/compositionLibraryEncoded.ts'
import type { QueryTypes } from '#src/search.ts'
import { isOfType } from '#src/utils.ts'

export class OrderTemplate extends CompositionLibraryEncoded {
  constructor(
    data?: ConstructorParameters<typeof CompositionLibraryEncoded>[0]
  ) {
    super({
      topic: [OrderTemplate.libraryTopic],
      ...data,
    })
  }

  static build(
    data?: ConstructorParameters<typeof CompositionLibraryEncoded>[0]
  ): OrderTemplate {
    return new OrderTemplate({
      ...data,
    })
  }

  static searchQuery(): QueryTypes {
    return {
      topic: OrderTemplate.libraryTopic,
      status: 'active',
      _sort: '-_lastUpdated',
    }
  }

  get sections(): OrderTemplateSection[] {
    return this.getSections<OrderTemplateSection>()
  }

  set sections(sections: OrderTemplateSection[]) {
    this.setSections(sections)
  }

  static libraryTopic = codeableConcept({
    system: LIBRARY_TOPIC,
    code: 'order',
    display: 'Order',
  })

  get allowValidatedTools(): boolean {
    return false
  }

  get maxSectionsCount(): number {
    return 1
  }

  static isInstance(value: unknown): value is OrderTemplate {
    return (
      isResource(value) &&
      isOfType(value, 'Library') &&
      hasCodeableConcept(value.topic, OrderTemplate.libraryTopic)
    )
  }
}

export interface OrderTemplateSection extends LibrarySection {}
